// Yönetim paneli (/yonetim/panel) üst-seviye sekmeleri - admin kullanıcı rolü/izinleri
// bu listeye göre hangi sekmelerin görünür olacağını belirler. Yeni bir sekme eklenirse
// buraya da eklenmeli, aksi halde yeni sekme izinli adminlere hiç görünmez.
const ADMIN_PAGES = [
  { key: 'dashboard', label: '📊 Genel Bakış' },
  { key: 'registrations', label: 'Kayıt Başvuruları' },
  { key: 'branches', label: 'Şube Talepleri' },
  { key: 'firms', label: 'CRM Firmaları' },
  { key: 'subscriptions', label: '💳 Abonelikler' },
  { key: 'custom_companies', label: '🏢 Firma Yönetim Ekranı' },
  { key: 'call_center', label: '📞 Çağrı Merkezi' },
  { key: 'industries', label: 'Sektör Ayarları' },
  { key: 'ai-center', label: '🤖 AI Center' },
  { key: 'reports', label: '📈 Raporlar' },
  { key: 'announcements', label: '📢 Duyurular' },
  { key: 'brands', label: '🎨 Marka Ayarları' },
  { key: 'api', label: '🔌 API Yönetimi' },
  { key: 'admins', label: '👤 Admin Kullanıcıları' }
];

export default ADMIN_PAGES;
